const white = '#FFFFFF'
const terraSky = '#5493F7'
const bg = '#0D0D0D'

const darkGray = '#202020'
const darkGray2 = '#2e2e2e'
const skyGray = '#727e8b'
const blueGray = '#474d57'
const black = '#1E1E1E'
const red = '#D64C55'
const orange = '#EDA34E'

const primary = terraSky
const text = white
const footerBg = darkGray

export default {
  white,
  terraSky,
  darkGray,
  darkGray2,
  skyGray,
  blueGray,
  black,
  red,
  orange,
  bg,

  primary,
  text,
  footerBg,
}
